import { createApi, retry } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "api";
import { PointList } from "models/point";
import { ApiRoute } from "utils";

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 });

export const pointApi = createApi({
  reducerPath: "pointApi",
  baseQuery: baseQueryWithRetry,
  keepUnusedDataFor: 0,
  refetchOnMountOrArgChange: true,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (build) => ({
    getSelfPoints: build.query<{ points: string; expiry_date: string }, {}>({
      query: () => {
        return {
          url: `${ApiRoute.CURRENT_USER.POINTS}`,
          validateStatus: (response, result) =>
            response.status === 200 && !result.isError,
        };
      },
      transformResponse: (response: {
        points: string;
        expiry_date: string;
      }) => {
        console.log("Res", response);
        return response;
      },
    }),
    getPoints: build.query<PointList, {}>({
      query: () => {
        return {
          url: `${ApiRoute.POINTS}`,
          validateStatus: (response, result) =>
            response.status === 200 && !result.isError,
        };
      },
      transformResponse: (response: { data: PointList }) => {
        return response.data;
      },
    }),
  }),
});

export const { useGetSelfPointsQuery, useGetPointsQuery } = pointApi;
